import { NetworkBasePopUp } from '../NetworkBasePopUp';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';

export class ReconfigureAgentPopUp extends NetworkBasePopUp<undefined> {
  protected title = ''; // not used
  protected extraDialogConfigs = {}; // not used
  protected async handleConfirmButtonClicked(event: CustomEvent) {} // not used

  protected customSetup() {
    const controller = app.getController(
      'Application.modules.network.controller.endpoints.tasks.modifyInstallerTaskController'
    );
    if (!controller.networkGrid) {
      controller.networkGrid = {};

      // only need to override this function, networkGrid Object is the old network grid, that's why we need to override things
      controller.networkGrid.controller = {
        convertProtectedEntitiesToTargets: (data: Array<ProtectedEntity>) => {
          return data.map(target => {
            return {
              protectedEntityId: target._id,
              name: target.name,
              type: target.type,
              isSva: target.specifics.isSva ?? false,
              path: target.path,
              company: target.company,
            };
          });
        },
      };
    }

    const companyIds = this.getCompanyIdsFromTargets();
    controller.customCreationSuccessNotification = () => this.showTaskCreatedToast();
    controller.customCreationFailureNotification = (message: string) => this.showErrorToastNotification(message);
    controller.createReconfigureInstallerTaskPanel(companyIds, this.data.targets);
  }

  private getCompanyIdsFromTargets() {
    const selectedProtectedEntities: Array<ProtectedEntity> = this.data.targets as Array<ProtectedEntity>;
    const companyIds = selectedProtectedEntities
      .map(entity => {
        if (entity.type === Constants.Companies.TYPE_COMPANY) {
          return entity._id;
        }

        return entity.company?.id;
      })
      .filter(companyId => companyId !== undefined);

    return [...new Set(companyIds)];
  }
}
